/**
 * @fileoverview Feature flags
 */

export default function Flags(...data) {
  let defaults = {
    showSupport: false
  }

  return Object.assign(defaults, ...data)
}
